import React from "react";
import { getAppState, withAppState } from "../../state";
import { withSubtheme } from "../../styles/themes/withSubtheme";
import FreeLogo from "../../components/FreeLogo";
import ProfileItem from "../../components/MultipleProfiles/ProfileItem";
import { withFocusable, Loading } from "../../services/visualLibraryService";
import { getPreferredLanguage } from "../../utils/perferedLanguage";

import { showAppExitConfirmationModal, showUserAccountCallFailedModal } from "../../services/modalsService";
import {
  ImageStyled,
  ImageDefaultStyled,
  ContainerStyled,
  TextStyled,
  PageContentStyled,
  HeadingStyled,
  ProfileListStyled,
  LogoContainerStyled
} from "./styles/Styled";
import { getNavigationReferences, redirectTo } from "../../services/navigationService";
import { routes } from "../../routes";
import getRemoteKey from "../../services/remoteService";
import { i18n } from "../../services/i18nService";
import { showNotLoggedModal } from "../../services/modalsService";
import {
  deleteCurrentProfileInIndexDB,
  getAllProfiles,
  getCurrentProfile,
  getProfileAvatars,
  updateCurrentProfileInIndexDB
} from "../../services/multipleProfilesService";
import { getSdk } from "../../services/sdkService";
import { isFromContentDetailsPath, setActiveUserRedirectionPath } from "../../utils/activeUserRedirectionUtils";
import { trackEvent } from "../../services/analyticsService";

const ProfileItemFocus = withFocusable(ProfileItem);
const defaultFocusPath = "profile_item_0";
const PROFILE_ITEM = "profile_item";
const MP = "MP";
const RTL = "rtl";
const KIDS = "kids";
const LAYOUT = "layout";
const DEFAULT_IMAGE = "/images/background-3.png";

const IMAGE = "image";
const EDIT = "edit";
const PATH = "path";
const SVG = "svg";
const IMG = "img";

class ProfileSelector extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isLoaded: false,
      profiles: null,
      focusedItemIndex: 2,
      selectedProfileIndex: 0,
      currentBackgroundSlideIndex: 0,
      currentFocusedProfilesBackground: null,
      backGroundImagesJSON: null
    };
    this.currentProfile = null;
    this.showLoginSignupModal = false;
    this.showExitModal = false;
    this.keydownHandler = this.keydownHandler.bind(this);
    this.handleEnter = this.handleEnter.bind(this);
    this.optionClicked = this.optionClicked.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.profileRedirectionPath = this.profileRedirectionPath.bind(this);
    this.nextBackground = this.nextBackground.bind(this);
    this.startSlidingBackground = this.startSlidingBackground.bind(this);
    this.onBack = this.onBack.bind(this);
    this.resetValuesOnProfileChange = this.resetValuesOnProfileChange.bind(this);
  }

  async componentDidMount() {
    this.props.resumeNavigation();
    this.props.onRef(this);
    document.addEventListener("keydown", this.keydownHandler);
    const { location } = this.props.history;
    if (location?.referrer !== "/pin" && location?.referrer !== "/") {
      try {
        await getSdk().userManager.get({ avoidCache: true });
      } catch (error) {
        showUserAccountCallFailedModal.call(this);
        throw error;
      }
    }
    let profilesData = await getAllProfiles();
    this.currentProfile = await getCurrentProfile();
    const avatarsList = await getProfileAvatars();
    if (profilesData && profilesData.length < 5) {
      const addProfile = {
        avatar: "/images/icons/add-profile.png",
        profileName: i18n.get("pages.profileSelector.addProfile"),
        createNewProfile: true
      };
      profilesData = [...profilesData, addProfile];
    }
    this.setState({ profiles: profilesData });
    // Find Selected Profile
    let selectedProfileIndex = 0;
    let profileNotExist = false;
    if (this.currentProfile && location?.referrer !== "/add-profile") {
      profileNotExist = this.state.profiles.every(profile => profile.profileId !== this.currentProfile.profileId);
    }
    if (profileNotExist) {
      selectedProfileIndex = 0;
      await deleteCurrentProfileInIndexDB();
    } else if (this.state.profiles && this.currentProfile) {
      this.props.stateActions.setCurrentProfileId(this.currentProfile?.profileId);
      selectedProfileIndex = this.state.profiles.findIndex(
        profile => profile.profileId === this.currentProfile.profileId
      );
    } else {
      this.props.stateActions.setCurrentProfileId("");
    }
    this.setState(
      {
        selectedProfileIndex,
        avatarsList,
        isLoaded: true,
        backGroundImagesJSON: getAppState().remoteProfileScreenBackGround,
        isEnabled: getAppState().remoteProfileScreenBackGround?.samsungtv?.active,
        sliderTimer: parseInt(getAppState().remoteProfileScreenBackGround?.samsungtv?.imageRotateTimeInSeconds) * 1000 // in milliseconds
      },
      () => {
        this.getProfileTypeAndParentalControl(
          this.state.profiles[this.state.selectedProfileIndex]?.parentalControl,
          this.state.profiles[this.state.selectedProfileIndex]?.profileCategory
        );
      }
    );
    this.props.setFocus(`${PROFILE_ITEM}_${selectedProfileIndex}`);
    trackEvent("profiles_list_viewed", null, MP, this.currentProfile);
  }

  async componentDidUpdate() {
    let profilesData = await getAllProfiles();
    if (profilesData && profilesData.length < 5) {
      const addProfile = {
        avatar: "/images/icons/add-profile.png",
        profileName: i18n.get("pages.profileSelector.addProfile"),
        createNewProfile: true
      };
      profilesData = [...profilesData, addProfile];
    }
    if ((this.state.profiles && this.state.profiles.length) !== (profilesData && profilesData.length)) {
      this.setState({ profiles: profilesData });
    }
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.keydownHandler);
    clearInterval(this.slideInterval);
  }

  keydownHandler = e => {
    if (this.showExitModal || this.showLoginSignupModal) return;
    const { profiles, selectedProfileIndex } = this.state;
    const pressedKey = getRemoteKey(e.keyCode);
    const direction = i18n.getDirection();
    if (pressedKey === "ARROW_UP" && selectedProfileIndex !== 0) {
      this.setState(
        {
          selectedProfileIndex: selectedProfileIndex - 1,
          focusedItemIndex: 2
        },
        () => {
          clearInterval(this.slideInterval);
          this.getProfileTypeAndParentalControl(
            profiles[this.state.selectedProfileIndex]?.parentalControl,
            profiles[this.state.selectedProfileIndex]?.profileCategory
          );
        }
      );
    } else if (pressedKey === "ARROW_DOWN" && selectedProfileIndex !== profiles.length - 1) {
      this.setState(
        {
          selectedProfileIndex: selectedProfileIndex + 1,
          focusedItemIndex: 2
        },
        () => {
          clearInterval(this.slideInterval);
          this.getProfileTypeAndParentalControl(
            profiles[this.state.selectedProfileIndex]?.parentalControl,
            profiles[this.state.selectedProfileIndex]?.profileCategory
          );
        }
      );
    } else if (
      (direction !== RTL && pressedKey === "ARROW_LEFT") ||
      (direction === RTL && pressedKey === "ARROW_RIGHT")
    ) {
      this.setState({
        focusedItemIndex: 1
      });
    } else if (
      (direction !== RTL && pressedKey === "ARROW_RIGHT") ||
      (direction === RTL && pressedKey === "ARROW_LEFT")
    ) {
      this.setState({
        focusedItemIndex: 2
      });
    }
  };

  onBack() {
    if (this.showExitModal || this.showLoginSignupModal) {
      this.closeModal();
      return true;
    }
    const { location } = this.props.history;
    if (location.state?.from === LAYOUT) {
      this.props.history.goBack();
    } else if (this.state.isLoaded) {
      this.showExitModal = true;
      showAppExitConfirmationModal.call(this, this.closeModal, false);
    }
    return true;
  }

  closeModal() {
    const {
      stateActions: { hideGlobalModal }
    } = this.props;
    const { selectedProfileIndex } = this.state;
    hideGlobalModal();
    this.showExitModal = false;
    this.showLoginSignupModal = false;
    this.props.setFocus(`${PROFILE_ITEM}_${selectedProfileIndex}`);
  }

  async handleEnter() {
    const sdk = await getSdk();
    const { focusedItemIndex, profiles, selectedProfileIndex, avatarsList } = this.state;
    const { location } = this.props.history;
    const userLogged = getAppState().userLogged;
    const selectedItem = profiles.find((item, index) => index === selectedProfileIndex);
    const isDeepLinkReferrer = location.state && !!location.state.deepLinkReferrer;
    if ((focusedItemIndex === 1 || focusedItemIndex === 2) && selectedItem.createNewProfile) {
      if (!userLogged) {
        this.showLoginSignupModal = true;
        showNotLoggedModal.call(this, getNavigationReferences.call(this), this.closeModal, null, false, false);
      } else {
        trackEvent("add_profile_click", null, MP, this.currentProfile);
        redirectTo.call(this, routes.profileName, {
          backDestination: routes.profileSelector,
          profileData: { profileName: "" },
          profileName: "",
          avatar: avatarsList && avatarsList.length > 0 ? avatarsList[0] : "/images/icons/add-profile.png",
          isFromAddProfile: true,
          ...(isDeepLinkReferrer && { deepLinkReferrer: true })
        });
      }
    } else if (focusedItemIndex === 2) {
      this.props.stateActions.setCurrentProfileId(selectedItem?.profileId);
      trackEvent("profile_clicked", null, MP, selectedItem);
      const profileRedirectionPath = await this.profileRedirectionPath(selectedItem);
      await sdk.mediaManager.clearLayoutCache();
      await sdk.userManager.setLanguage(selectedItem.language);
      this.props.stateActions.setLocale(selectedItem.language);
      localStorage.setItem("parentalLevel", selectedItem.parentalControl);
      localStorage.setItem("locale", selectedItem.language);
      localStorage.setItem("currentProfileSPXToken", selectedItem.token);
      localStorage.setItem("currentProfileId", selectedItem.profileId);
      if (selectedItem?.isProfileLocked) {
        this.resetValuesOnProfileChange(selectedItem);
        redirectTo.call(this, routes.pinLock, {
          profileId: selectedItem.profileId,
          isVerifyPin: true,
          profileData: selectedItem,
          fromProfileSelector: true,
          backDestination: routes.profileSelector,
          nextPageReference: profileRedirectionPath,
          profileName: selectedItem.profileName,
          ...(isDeepLinkReferrer && { deepLinkReferrer: true })
        });
      } else {
        this.setState({ isLoaded: false }, async () => {
          this.resetValuesOnProfileChange(selectedItem);
          await updateCurrentProfileInIndexDB({ ...selectedItem, isGenerateJWTToken: true });
          this.props.applicationState.preferredLanguage = await getPreferredLanguage();
          redirectTo.call(this, profileRedirectionPath, isDeepLinkReferrer ? { deepLinkReferrer: true } : null);
          this.setState({ isLoaded: true });
        });
      }
    } else {
      if (!selectedItem.avatar) {
        selectedItem.avatar = avatarsList && avatarsList.length > 0 && avatarsList[0];
      }
      trackEvent("profiles_edit_start", null, MP, selectedItem);
      redirectTo.call(this, routes.editProfile, {
        profileData: selectedItem,
        oldProfileData: selectedItem,
        ...(isDeepLinkReferrer && { deepLinkReferrer: false })
      });
    }
  }

  reloadWait(ms) {
    return new Promise(resolve => (this.clearRefreshTimeout = setTimeout(resolve, ms)));
  }

  async optionClicked(itemIndex, target) {
    const { profiles, avatarsList } = this.state;
    const sdk = await getSdk();
    const selectedItem = profiles.find((item, index) => index === itemIndex);
    const { location } = this.props.history;
    const userLogged = getAppState().userLogged;
    const isDeepLinkReferrer = location.state && !!location.state.deepLinkReferrer;

    if (target.name === IMAGE || target.tagName === IMG) {
      if (this.state.focusedItemIndex === 1) {
        this.setState({
          focusedItemIndex: 2
        });
        await this.reloadWait(100);
      }
      if (selectedItem.createNewProfile) {
        this.setState({
          selectedProfileIndex: profiles.length - 1
        });
        if (!userLogged) {
          this.showLoginSignupModal = true;
          showNotLoggedModal.call(this, getNavigationReferences.call(this), this.closeModal, null, false, false);
        } else {
          trackEvent("add_profile_click", null, MP, this.currentProfile);
          redirectTo.call(this, routes.profileName, {
            backDestination: routes.profileSelector,
            profileData: { profileName: "" },
            profileName: "",
            avatar: avatarsList && avatarsList.length > 0 ? avatarsList[0] : "/images/icons/add-profile.png",
            isFromAddProfile: true,
            ...(isDeepLinkReferrer && { deepLinkReferrer: true })
          });
        }
      } else {
        this.props.stateActions.setCurrentProfileId(selectedItem?.profileId);
        trackEvent("profile_clicked", null, MP, selectedItem);
        const profileRedirectionPath = await this.profileRedirectionPath(selectedItem);
        await sdk.mediaManager.clearLayoutCache();
        await sdk.userManager.setLanguage(selectedItem.language);
        this.props.stateActions.setLocale(selectedItem.language);
        localStorage.setItem("parentalLevel", selectedItem.parentalControl);
        localStorage.setItem("locale", selectedItem.language);
        if (selectedItem?.isProfileLocked) {
          this.resetValuesOnProfileChange(selectedItem);
          redirectTo.call(this, routes.pinLock, {
            profileId: selectedItem.profileId,
            isVerifyPin: true,
            profileData: selectedItem,
            fromProfileSelector: true,
            backDestination: routes.profileSelector,
            nextPageReference: profileRedirectionPath,
            profileName: selectedItem.profileName,
            ...(isDeepLinkReferrer && { deepLinkReferrer: true })
          });
        } else {
          this.setState({ isLoaded: false }, async () => {
            this.resetValuesOnProfileChange(selectedItem);
            await updateCurrentProfileInIndexDB({ ...selectedItem, isGenerateJWTToken: true });
            this.props.applicationState.preferredLanguage = await getPreferredLanguage();
            redirectTo.call(this, profileRedirectionPath, isDeepLinkReferrer ? { deepLinkReferrer: true } : null);
            this.setState({ isLoaded: true });
          });
        }
      }
    }
    if (target.name === EDIT || target.tagName === PATH || target.tagName === SVG) {
      if (!selectedItem.avatar) {
        selectedItem.avatar = avatarsList && avatarsList.length > 0 && avatarsList[0];
      }
      trackEvent("profiles_edit_start", null, MP, selectedItem);
      this.setState({
        focusedItemIndex: 1
      });
      await this.reloadWait(100);

      redirectTo.call(this, routes.editProfile, {
        profileData: selectedItem,
        oldProfileData: selectedItem,
        ...(isDeepLinkReferrer && { deepLinkReferrer: false })
      });
    }
  }

  async resetValuesOnProfileChange(selectedItem) {
    const sdk = await getSdk();
    await sdk.mediaManager.clearLayoutCache();
    await sdk.userManager.setLanguage(selectedItem.language);
    this.props.stateActions.setLocale(selectedItem.language);
    localStorage.setItem("parentalLevel", selectedItem.parentalControl);
    localStorage.setItem("locale", selectedItem.language);
    localStorage.setItem("currentProfileSPXToken", selectedItem.token);
    localStorage.setItem("currentProfileId", selectedItem.profileId);
  }

  async profileRedirectionPath(item) {
    const {
      applicationState: { userAccountStatus, userAddonStatus },
      history: {
        location: { referrer, state }
      }
    } = this.props;
    let containsExcludedPath = false;
    if (
      (referrer === "/login" && state?.nextPageReference) ||
      (userAccountStatus && state?.deepLinkReferrer && state?.nextPageReference)
    ) {
      containsExcludedPath = isFromContentDetailsPath(state?.nextPageReference);
    }
    if (item?.profileCategory.toLowerCase() === KIDS && !containsExcludedPath) {
      return routes.home;
    } else if ((userAccountStatus || userAddonStatus) && !containsExcludedPath) {
      const activeUserRedirectLanding = await setActiveUserRedirectionPath();
      return activeUserRedirectLanding;
    } else if (containsExcludedPath && state?.nextPageReference) {
      return state?.nextPageReference;
    }
    return routes.home;
  }

  isBackgroundSildeShowEnabled(index, profiles) {
    if (this.state.isEnabled && profiles && profiles.length > 0) {
      if (profiles[index]?.isProfileLocked) {
        clearInterval(this.slideInterval);
        return false;
      } else if (profiles[index]?.isKidLockEnabled) {
        clearInterval(this.slideInterval);
        return false;
      } else if (profiles[index]?.createNewProfile) {
        clearInterval(this.slideInterval);
        return false;
      } else {
        return true;
      }
    } else {
      clearInterval(this.slideInterval);
      return false;
    }
  }

  async getProfileTypeAndParentalControl(parentalControl, profileCategory) {
    const profileBackgroundImageData =
      this.state.backGroundImagesJSON && this.state.backGroundImagesJSON.profileBackgroudImage;
    const filterData = profileBackgroundImageData?.filter(
      item => item.ParentalControl === parentalControl && item.type.toUpperCase() === profileCategory
    );

    const imageSlides = filterData
      .map(item => item[`urls_${localStorage.getItem("locale")}`])
      .reduce((acc, val) => acc.concat(val), []);

    await this.preloadImages(imageSlides);

    this.setState(
      {
        currentFocusedProfilesBackground: imageSlides
      },
      () => {
        this.startSlidingBackground();
      }
    );
  }

  async preloadImages(imageSlides) {
    const loadedImages = [];
    imageSlides.forEach(src => {
      const img = new Image();
      img.src = src;
      img.onload = () => {
        loadedImages.push(img);
      };
    });
  }

  startSlidingBackground() {
    this.slideInterval = setInterval(this.nextBackground, this.state.sliderTimer);
  }

  nextBackground() {
    setTimeout(() => {
      this.setState(prevState => ({
        currentBackgroundSlideIndex:
          (prevState.currentBackgroundSlideIndex + 1) % this.state.currentFocusedProfilesBackground.length
      }));
    }, 3000);
  }

  render() {
    const {
      isLoaded,
      profiles,
      selectedProfileIndex,
      avatarsList,
      currentFocusedProfilesBackground,
      currentBackgroundSlideIndex
    } = this.state;

    return (
      <>
        {isLoaded ? (
          <section>
            {!this.isBackgroundSildeShowEnabled(selectedProfileIndex, profiles) ? (
              <ImageDefaultStyled src={DEFAULT_IMAGE} alt="" width={"100%"} />
            ) : currentFocusedProfilesBackground !== null ? (
              currentFocusedProfilesBackground.map((images, index) => (
                <ImageStyled
                  key={index}
                  src={images}
                  alt=""
                  width={"100%"}
                  className={index === currentBackgroundSlideIndex ? "active" : ""}
                />
              ))
            ) : (
              <ImageDefaultStyled src={DEFAULT_IMAGE} alt="" width={"100%"} />
            )}

            {profiles[selectedProfileIndex]?.createNewProfile ? (
              <ContainerStyled>
                <HeadingStyled
                  rank={1}
                  text={i18n.get("pages.profileSelector.customizeYourSTARZPLAYJourney")}
                  size={"mediumLarge"}
                  textAlign={"center"}
                />
                <TextStyled text={i18n.get("pages.profileSelector.createIndividualProfilesForMembers")} size="small" />
              </ContainerStyled>
            ) : profiles[selectedProfileIndex]?.isProfileLocked ? (
              <ContainerStyled>
                <HeadingStyled
                  rank={1}
                  text={i18n.get("pages.profileSelector.lockedProfile.adult.heading")}
                  size={"mediumLarge"}
                  textAlign={"center"}
                />
                <TextStyled text={i18n.get("pages.profileSelector.lockedProfile.adult.subHeading")} size="small" />
              </ContainerStyled>
            ) : (
              profiles[selectedProfileIndex]?.isKidLockEnabled && (
                <ContainerStyled>
                  <HeadingStyled
                    rank={1}
                    text={i18n.get("pages.profileSelector.lockedProfile.kids.heading")}
                    size={"mediumLarge"}
                    textAlign={"center"}
                  />
                  <TextStyled text={i18n.get("pages.profileSelector.lockedProfile.kids.subHeading")} size="small" />
                </ContainerStyled>
              )
            )}
            <PageContentStyled>
              <LogoContainerStyled>
                <FreeLogo />
                <HeadingStyled
                  rank={1}
                  text={i18n.get("pages.profileSelector.whosWatching")}
                  size={"medium"}
                  fontWeight={"regular"}
                />
              </LogoContainerStyled>
              <ProfileListStyled>
                {profiles.map((item, index) => (
                  <ProfileItemFocus
                    key={index}
                    focusPath={`${PROFILE_ITEM}_${index}`}
                    currentIndex={this.state.focusedItemIndex}
                    profileItem={item}
                    defaultAvatar={avatarsList && avatarsList.length > 0 ? avatarsList[0] : null}
                    onEnterPress={() => this.handleEnter(index)}
                    onMouseUp={event => this.optionClicked(index, event.target)}
                  />
                ))}
              </ProfileListStyled>
            </PageContentStyled>
          </section>
        ) : (
          <Loading overlay />
        )}
      </>
    );
  }
}

const Component = withAppState(withSubtheme(ProfileSelector));

Component.defaultFocusPath = defaultFocusPath;

export default Component;
